import { render, staticRenderFns } from "./VideoCardRecommend.vue?vue&type=template&id=59ead75c&"
import script from "./VideoCardRecommend.vue?vue&type=script&lang=js&"
export * from "./VideoCardRecommend.vue?vue&type=script&lang=js&"
import style0 from "./VideoCardRecommend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports